module.exports = __webpack_public_path__ + "static/media/merchandising.82d49612.svg";